import { useEffect } from 'react';
import useProjectData from '@hooks/useProjectData';
import {
  useModelFilterActions,
  useModelFiltersStore,
} from '@store/zustand/model-filters';

/**
 * Keeps the live CIA selection inside the project's current criteria
 * configuration.
 *
 * A criteria removed in Project settings, or an answer renamed there, would
 * otherwise stay selected under a key no entity can match and empty the
 * canvas with nothing in the popover to untick. The project query refreshes
 * `cia_criteria` after a settings save, so the configuration is read from
 * it and the selection pruned whenever it changes; it is pruned again
 * whenever the store's scope key changes, because a mode or workspace
 * switch restores a parked selection that was never checked against this
 * configuration. No configuration — the project still loading, or no
 * questionnaire — prunes nothing, so a selection made before the project
 * arrived is not lost to a blank. Pruning only ever removes values, so it
 * can only reveal entities: it closes no drawer and needs no prompt.
 */
export const useReconcileCiaFilters = () => {
  const [{ questionnaire }] = useProjectData();
  const scopeKey = useModelFiltersStore((state) => state.scopeKey);
  const { reconcileCiaFilters } = useModelFilterActions();
  const criteria = questionnaire?.cia_criteria;

  useEffect(() => {
    if (criteria) {
      reconcileCiaFilters(criteria);
    }
  }, [criteria, scopeKey]);
};
